import { getUploadFn } from './upload';
import { canUseProxy } from './utils';
import time from './time';

class DataLayerListener {
  constructor(dataLayerName, uploadType) {
    this.dataLayerName = dataLayerName;
    this.uploadType = uploadType;
    this.deleteP = '';
    this.init();
  }

  init() {
    let _this = this;
    if (
      Object.prototype.toString.call(window[this.dataLayerName]) !==
      '[object Array]'
    ) {
      console.warn(`hw dataLayer error:reset ${this.dataLayerName} as []`);
      window[this.dataLayerName] = [];
    } else if (window[this.dataLayerName].length) {
      this.beginCheckDataLayer();
    }

    if (canUseProxy()) {
      window[this.dataLayerName] = new Proxy(window[this.dataLayerName], {
        set(target, property, value) {
          let isDeletePoint = property == 'length' && target.length > value;
          if (Object.prototype.toString.call(value) == '[object Object]') {
            let _time = time();
            value['pointDate'] = _time.pointDate;
            value['pointTime'] = _time.pointTime;
            value['pointTimestamp'] = _time.pointTimestamp;
          }
          target[property] = value;
          if (!isDeletePoint && property == 'length') {
            _this.beginCheckDataLayer();
          }
          return true;
        }
      });
    }

    window.addEventListener('beforeunload', () => {
      _this.beginCheckDataLayer();
    });
  }

  async consumePoint(pointInfo) {
    let fn = await getUploadFn(this.uploadType);
    if (!pointInfo) {
      return Promise.resolve();
    }
    return new Promise(async resolve => {
      if (
        Object.prototype.toString.call(window.requestIdleCallback) ==
        '[object Function]'
      ) {
        window.requestIdleCallback(async () => {
          fn(pointInfo);
          resolve(void 0);
        });
      } else {
        fn(pointInfo);
        resolve(void 0);
      }
    });
  }

  async beginCheckDataLayer() {
    if (window[this.dataLayerName].length) {
      let pointInfo = window[this.dataLayerName].shift();
      await this.consumePoint(pointInfo);
      this.beginCheckDataLayer();
    }
  }
}

export default DataLayerListener;
